import React, { useState, useEffect } from "react";
import { Table, Pagination, Checkbox } from "antd";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import { set } from "immutable";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import axios from "axios";
import moment from "moment";
import { Input } from "antd";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import { useForm, Controller, Feedback } from "react-hook-form";
import DatePicker from "react-datepicker";
import Formulario from "./FormularioP";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import { URL_EMPLOYEE } from "../../constans/servidor";
import PaginationComponent from "../Desenganche/pagination";
const TableComponent = (props) => {
  const { data, nit } = props;
  const [loadingData, setLoadingData] = useState(false);
 
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [placa, setPlaca] = useState();
  const [placass, setPlacass] = useState();
  const [estado, setEstado] = useState();
  const [fecha_hora, setFecha_hora] = useState([]);
  const [nom_terminal, setNom_terminal] = useState();
  const [cod_terminal, setCod_terminal] = useState();
  const [cod_park, setCod_park] = useState();
  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [buscar, setBuscar] = useState(data);
  const [dplaca, setdPlaca] = useState([]);
  const [contrato, setdContrato] = useState([]);
  const [id, setdId] = useState([]);
  const [dplaca1, setdPlaca1] = useState([]);
  const [dplaca2, setdPlaca2] = useState([]);
  const [dataPagination, setDataPagination] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [objeto, setObjeto] = useState([]);
  const [crear, setCrear] = useState(false);
  const [showPagination, setShowPagination] = useState(true);
  let handleSearch = "";
  let handleRowClick = "";
  const {
    control,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const regExpCarro = /^[a-z A-Z]{3}[0-9]{3}$/;
  const regExpCarroR = /^[a-z A-Z]{1}[0-9]{4}$/;
  const regExpCarroA = /^[a-z A-Z]{2}[0-9]{4}$/;
  const regExpCarroV = /^[a-z A-Z]{1}[0-9]{5}$/;
  const regExpMoto = /^[a-z A-Z]{3}[0-9]{2}[a-z A-Z]{1}$/;
  const regExpMotoAntigua = /^[a-z A-Z]{3}[0-9]{2}$/;
  const regExpBici = /^BICI[0-9]{3}$/;
  const regExpBici2 = /^BICI[0-9]{2}$/;

  const verificarPlaca = (placa) => {
    console.log(placa);
    if (
      regExpCarro.test(placa) ||
      regExpCarroR.test(placa) ||
      regExpCarroA.test(placa) ||
      regExpCarroV.test(placa) ||
      regExpMoto.test(placa) ||
      regExpMotoAntigua.test(placa) ||
      regExpBici.test(placa) ||
      regExpBici2.test(placa)
    ) {
      setPlaca(true);
    } else {
      setPlaca(false);
    }
  };
  useEffect(() => {
    console.log("data");
    console.log(data);
    setFilterData(data);
    setTimeout(() => {
      setEstado(1);
    }, 800);
  }, [data]);
 
  const confirmar = async (data) => {
    setModal(false);
    const parametros = [];
    for (let i = 0; i < dplaca.length; i++) {
      parametros.push({
        idMonthlyContract: contrato[i],
        plate: dplaca[i],
      });
    }
    try {
      function reloadPage() {
        window.location.reload();
      }
      console.log(parametros);
      const resultado = await axios.post(
        `${URL_EMPLOYEE}/monthlyInstallment/disable/lpr/disablePlate`,
        parametros
      );
      if (resultado.data["statusCode"] == 200) {
        toast.success("Placa desactivada exitosamente");
        setInterval(reloadPage, 2000);
      } else {
        toast.error("Error al desactivar la placa");
      }
    } catch (error) {
      toast.error("Algo salio mal..");
      setLoadingData(false);
    }
  };
  handleRowClick = (row) => {
    const isSelected = selectedRows.includes(row);
    setSelectedRows(
      isSelected
        ? selectedRows.filter((selectedRow) => selectedRow !== row)
        : [...selectedRows, row]
    );
    setdPlaca2(row.plate);
    if (isSelected) {
      console.log("estoy desseleccionado");
      if (dplaca.includes(row.plate)) {
        const newDplaca = dplaca.filter((placa) => placa !== row.plate);
        const newId = id.filter((id) => id !== row.id);
        setdPlaca(newDplaca);
        setdId(newId);
        setdPlaca1("-" + newDplaca + " ");
      }
    } else {
      if (!dplaca.includes(row.plate)) {
        const newDplaca = [...dplaca, row.plate];
        const newContrato = [...contrato, row.idMonthlyContract];
        const newId = [...id, row.id];
        setdPlaca(newDplaca);
        setdContrato(newContrato);
        setdId(newId);
        // setFecha_hora(newDfecha)
        setdPlaca1("-" + newDplaca + " ");
      }
    }
    setNom_terminal(row.nombre_park);
    setCod_terminal(row.cod_terminal);
    setCod_park(row.cod_park);
    setFecha_hora(row.fecha_hora);
  };

  handleSearch = (event) => {
    const searchTerm = event.target.value.toUpperCase();
    setSearchTerm(searchTerm);

    if (data && data.length > 0) {
      let filteredData = data.filter((row) =>
        Object.values(row).some((value) =>
          value.toString().toUpperCase().includes(searchTerm)
        )
      );
      setFilteredData(filteredData);
      setShowPagination(false);
    }
  };
  return (
    <div>
      {!modal1 ? (
        <Row className="justify-content-end mbottom-40">
          <Button
            onClick={() => {
              setModal1(true);
            }}
            type="buttom"
            variant="primary"
            className=" btn btn-primary mtop-20 boton"
          >
            Crear Placa
          </Button>
        </Row>
      ) : null}
      {modal1 ? (
        <>
          <Row className="justify-content-end mbottom-40">
            <Button
              onClick={() => {
                setModal1(false);
              }}
              type="buttom"
              variant="primary"
              className=" btn btn-primary mtop-20 boton"
            >
              Cerrar Formulario
            </Button>
          </Row>
          <Formulario modal={modal1} nit={nit}></Formulario>
        </>
      ) : null}
      {data ? (
        <>
          <Row className="justify-content-end mbottom-40">
            <input
              className="buscar inputplaca"
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearch}
            />
          </Row>
          <table className="tabla ">
            <thead>
              <tr>
                <th></th>
                <th>Id</th>
                <th>Id Contrato</th>
                <th>Documento</th>
                <th>Nombre</th>
                <th>Placa</th>
                <th>Fecha Activación</th>
                <th>Fecha Expiración</th>
              </tr>
            </thead>
            {filteredData.length > 0 ? (
              <tbody>
                {filteredData.map((row) => (
                  <tr key={row.id} onClick={() => handleRowClick(row)}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(row)}
                        onChange={() => handleRowClick(row)}
                      />
                    </td>
                    <td>{row.id}</td>
                    <td>{row.idMonthlyContract}</td>
                    <td>{row.document}</td>
                    <td>{row.name}</td>
                    <td>{row.plate}</td>
                    <td>
                      {moment.utc(row.activationDate).format("DD/MM/YYYY")}
                    </td>
                    <td>
                      {moment.utc(row.expirationDate).format("DD/MM/YYYY")}
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan="8">No se encontraron resultados</td>
                </tr>
              </tbody>
            )}
          </table>
          <div className="pagination-container">
            {showPagination && (
              <div className="float-right pagination">
                <PaginationComponent
                  data={data}
                  setDataPagination={setFilteredData}
                  title="Posts"
                  pageLimit={10}
                  dataLimit={50}
                />
              </div>
            )}
          </div>
          <Row className="btn-flotante float-right justify-content-end mtop-40 mbottom-20">
            <Button
              onClick={() => {
                setModal(true);
              }}
              type="buttom"
              variant="primary"
              className=" btn btn-primary mtop-20 boton"
              className="btn-desactivar"
            >
              Desactivar
            </Button>
          </Row>
        </>
      ) : (
        <h4 style={{ color: "#008b9c" }}>
          Aun no hay placas asociadas a este contrato
        </h4>
      )}
      <Modal show={modal} onHide={() => setModal(false)} size="lg">
        <form onSubmit={handleSubmit(confirmar)}>
          <Modal.Header closeButton>
            <Modal.Title className="texto-slogan2">
              Confirmación Desactivación Placas
            </Modal.Title>
          </Modal.Header>
 
          <Modal.Body>
            <>
              <form onSubmit={handleSubmit(confirmar)}>
                <Row className="align-items-center">
                  <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <p>Placas seleccionadas: </p>
                  </Col>
                </Row>
                <Row>
                  <Col
                    className=" mbottom-40 texto-resaltado"
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                  >
                    {dplaca1}
                  </Col>
                </Row>
              </form>
            </>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="submit"
              onClick={() => {
                setModal(false);
              }}
              variant="secondary"
            >
              Atras
            </Button>
            <Button
              type="submit"
              className=" btn2 btn2-primary  boton"
              variant="primary"
            >
              Confirmar{" "}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
 
export default TableComponent;